import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['specialNeedsSection'];

  connect() {
    this.toggleVisibility();
  }

  toggleVisibility() {
    const isChecked = this.checkbox.checked;
    if (isChecked) {
      this.specialNeedsSectionTarget.classList.remove('tw-hidden');
    } else {
      this.specialNeedsSectionTarget.classList.add('tw-hidden');
    }
  }

  get checkbox() {
    return this.element.querySelector("input[type='checkbox']");
  }
}
